/**
 * @generated SignedSource<<a2ac7700c7a64ff9bfe3328d0eb2f86d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecruitDetailsQuery_Query$variables = {
  count: number;
  recruitId: string;
  search?: string | null;
  studyId: string;
};
export type RecruitDetailsQuery_Query$data = {
  readonly viewer: {
    readonly recruit: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"RecruitDetails_recruit">;
    } | null;
    readonly study: {
      readonly " $fragmentSpreads": FragmentRefs<"RecruitDetails_study">;
    } | null;
    readonly user: {
      readonly " $fragmentSpreads": FragmentRefs<"RecruitDetails_user">;
    } | null;
  };
};
export type RecruitDetailsQuery_Query = {
  response: RecruitDetailsQuery_Query$data;
  variables: RecruitDetailsQuery_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recruitId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studyId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "studyId",
    "variableName": "studyId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "recruitId",
    "variableName": "recruitId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "needsReviewCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "screenerLink",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentiveType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalIncentivePerParticipantCostUsdCents",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitDetailsQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RecruitDetails_study"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "RecruitNode",
            "kind": "LinkedField",
            "name": "recruit",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RecruitDetails_recruit"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RecruitDetails_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "RecruitDetailsQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultIncentive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultIncentivePoints",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedulingType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedulingLink",
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availabilityBuffer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StudyAvailabilitySlotConnection",
                "kind": "LinkedField",
                "name": "availabilitySlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudyAvailabilitySlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StudyAvailabilitySlotNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "duration",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requireStudyPayment",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vpmAccountId",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailDomain",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "googleCalendarEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmailTemplateConnection",
                    "kind": "LinkedField",
                    "name": "emailTemplates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailTemplateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmailTemplateNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "replyTo",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subject",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enablePanelView",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDemoAccount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "voxpopmeGlobal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableCustomCommunityTab",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableHubuxPanel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allowPanelCapture",
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSelfSignup",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "namePublic",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ScreenerNode",
                "kind": "LinkedField",
                "name": "screener",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "count"
                  },
                  {
                    "kind": "Variable",
                    "name": "respondent_Person_FirstName_Icontains",
                    "variableName": "search"
                  },
                  {
                    "kind": "Literal",
                    "name": "respondent_Person_OptIn",
                    "value": true
                  }
                ],
                "concreteType": "ParticipantNodeConnection",
                "kind": "LinkedField",
                "name": "participants",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ParticipantNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParticipantNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RespondentNode",
                            "kind": "LinkedField",
                            "name": "respondent",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PersonNode",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "firstName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastName",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RecruitNode",
                                "kind": "LinkedField",
                                "name": "recruit",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isTest",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowAutoApproval",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitNodeConnection",
                "kind": "LinkedField",
                "name": "recruits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecruitNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "RecruitNode",
            "kind": "LinkedField",
            "name": "recruit",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v13/*: any*/),
              (v10/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "goal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incentive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incentivePoints",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitTransactionNodeConnection",
                "kind": "LinkedField",
                "name": "recruitTransactions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitTransactionNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecruitTransactionNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dbId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "underGoal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "overNeedsReviewLimit",
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meta",
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invitesSentCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitPersonCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "openedScreenerCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startedScreenerCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "completedScreenerCount",
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "qualifiedCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progressTowardGoalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalPayouts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalSpend",
                "storageKey": null
              },
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canHaveVoxpopmeGlobal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remindersEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StudyNode",
                "kind": "LinkedField",
                "name": "study",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TenantNode",
                    "kind": "LinkedField",
                    "name": "tenant",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stripePaymentMethodId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stripePaymentMethodLast4",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vpmUserId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PanelistNode",
                "kind": "LinkedField",
                "name": "panelist",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "45b4d6f81f08009a229dddcf45b6274f",
    "id": null,
    "metadata": {},
    "name": "RecruitDetailsQuery_Query",
    "operationKind": "query",
    "text": "query RecruitDetailsQuery_Query(\n  $studyId: String!\n  $recruitId: String!\n  $count: Int!\n  $search: String\n) {\n  viewer {\n    study(studyId: $studyId) {\n      ...RecruitDetails_study\n      id\n    }\n    recruit(recruitId: $recruitId) {\n      id\n      ...RecruitDetails_recruit\n    }\n    user {\n      ...RecruitDetails_user\n      id\n    }\n  }\n}\n\nfragment CommunicationComposePage_recruit on RecruitNode {\n  id\n  meta\n  name\n  type\n  dbId\n}\n\nfragment CommunicationComposePage_study on StudyNode {\n  dId\n  id\n  tenant {\n    name\n    emailDomain\n    googleCalendarEmail\n    dId\n    vpmAccountId\n    ...SaveTemplateModal_tenant\n    id\n  }\n  status\n  type\n  name\n  ...FormItemParticipants_study_3DeKgW\n}\n\nfragment CommunicationComposePage_user on UserNode {\n  email\n  dId\n  vpmUserId\n  panelist {\n    dId\n    id\n  }\n}\n\nfragment EditInvitationEmailModal_recruit on RecruitNode {\n  id\n  meta\n}\n\nfragment EditInvitationEmailModal_tenant on TenantNode {\n  emailTemplates {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  ...SelectTemplateModal_tenant\n  ...SaveTemplateModal_tenant\n}\n\nfragment FormItemParticipants_study_3DeKgW on StudyNode {\n  id\n  participants(first: $count, respondent_Person_FirstName_Icontains: $search, respondent_Person_OptIn: true) {\n    edges {\n      node {\n        respondent {\n          dId\n          person {\n            email\n            firstName\n            lastName\n            id\n          }\n          recruit {\n            isTest\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment RecruitDetails_recruit on RecruitNode {\n  id\n  type\n  status\n  name\n  goal\n  incentive\n  incentivePoints\n  recruitTransactions {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  dbId\n  ...RecruitInstructions_recruit\n  ...RecruitKPIs_recruit\n  ...RecruitNameModal_recruit\n  ...RecruitTitle_recruit\n  ...RecruitTypePicker_recruit\n  ...RecruitYourPanel_recruit\n  ...RecruitForm_recruit\n  ...RecruitPaymentModal_recruit\n}\n\nfragment RecruitDetails_study on StudyNode {\n  id\n  dId\n  name\n  needsReviewCount\n  status\n  screenerLink\n  incentiveType\n  defaultIncentive\n  defaultIncentivePoints\n  schedulingType\n  schedulingLink\n  type\n  meetingLink\n  availabilityBuffer\n  availabilitySlots {\n    edges {\n      node {\n        id\n        duration\n      }\n    }\n  }\n  tenant {\n    requireStudyPayment\n    name\n    dId\n    vpmAccountId\n    id\n  }\n  ...RecruitInstructions_study\n  ...RecruitKPIs_study\n  ...RecruitTitle_study\n  ...RecruitTypePicker_study\n  ...RecruitForm_study\n}\n\nfragment RecruitDetails_user on UserNode {\n  dId\n  vpmUserId\n  panelist {\n    dId\n    id\n  }\n  ...RecruitInstructions_user\n}\n\nfragment RecruitForm_recruit on RecruitNode {\n  id\n  name\n  type\n  status\n  goal\n  incentive\n  incentivePoints\n  remindersEnabled\n}\n\nfragment RecruitForm_study on StudyNode {\n  id\n  defaultIncentive\n  defaultIncentivePoints\n  incentiveType\n  name\n  namePublic\n  tenant {\n    enablePanelView\n    requireStudyPayment\n    externalIncentivePerParticipantCostUsdCents\n    isSelfSignup\n    id\n  }\n  screener {\n    description\n    id\n  }\n}\n\nfragment RecruitInstructions_recruit on RecruitNode {\n  type\n  status\n  underGoal\n  overNeedsReviewLimit\n  incentive\n  incentivePoints\n  incentiveType\n  ...CommunicationComposePage_recruit\n  ...ScreenerLink_recruit\n}\n\nfragment RecruitInstructions_study on StudyNode {\n  id\n  namePublic\n  status\n  incentiveType\n  screener {\n    title\n    id\n  }\n  tenant {\n    requireStudyPayment\n    id\n  }\n  ...CommunicationComposePage_study\n}\n\nfragment RecruitInstructions_user on UserNode {\n  email\n  ...CommunicationComposePage_user\n}\n\nfragment RecruitKPIs_recruit on RecruitNode {\n  type\n  status\n  goal\n  invitesSentCount\n  recruitPersonCount\n  openedScreenerCount\n  startedScreenerCount\n  completedScreenerCount\n  needsReviewCount\n  qualifiedCount\n  progressTowardGoalCount\n  totalPayouts\n  totalSpend\n}\n\nfragment RecruitKPIs_study on StudyNode {\n  allowAutoApproval\n  tenant {\n    requireStudyPayment\n    id\n  }\n}\n\nfragment RecruitNameModal_recruit on RecruitNode {\n  id\n  name\n  description\n}\n\nfragment RecruitPaymentModal_recruit on RecruitNode {\n  id\n  name\n  type\n  status\n  goal\n  incentiveType\n  incentive\n  incentivePoints\n  recruitTransactions {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  study {\n    tenant {\n      stripePaymentMethodId\n      stripePaymentMethodLast4\n      externalIncentivePerParticipantCostUsdCents\n      id\n    }\n    id\n  }\n}\n\nfragment RecruitTitle_recruit on RecruitNode {\n  id\n  type\n  name\n  description\n  status\n  incentiveType\n  incentivePoints\n  incentive\n  recruitTransactions {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  dbId\n  ...RecruitNameModal_recruit\n  ...EditInvitationEmailModal_recruit\n}\n\nfragment RecruitTitle_study on StudyNode {\n  id\n  dId\n  name\n  incentiveType\n  defaultIncentive\n  defaultIncentivePoints\n  type\n  meetingLink\n  schedulingType\n  schedulingLink\n  availabilitySlots {\n    edges {\n      node {\n        id\n        duration\n      }\n    }\n  }\n  tenant {\n    requireStudyPayment\n    name\n    dId\n    vpmAccountId\n    ...EditInvitationEmailModal_tenant\n    id\n  }\n  status\n}\n\nfragment RecruitTypePicker_recruit on RecruitNode {\n  id\n  type\n  status\n  goal\n  canHaveVoxpopmeGlobal\n}\n\nfragment RecruitTypePicker_study on StudyNode {\n  id\n  incentiveType\n  tenant {\n    enablePanelView\n    isDemoAccount\n    voxpopmeGlobal\n    enableCustomCommunityTab\n    enableHubuxPanel\n    allowPanelCapture\n    id\n  }\n  recruits {\n    edges {\n      node {\n        id\n        type\n      }\n    }\n  }\n}\n\nfragment RecruitYourPanel_recruit on RecruitNode {\n  id\n  status\n}\n\nfragment SaveTemplateModal_tenant on TenantNode {\n  emailTemplates {\n    edges {\n      node {\n        id\n        name\n        replyTo\n        subject\n        message\n      }\n    }\n  }\n}\n\nfragment ScreenerLink_recruit on RecruitNode {\n  screenerLink\n}\n\nfragment SelectTemplateModal_tenant on TenantNode {\n  emailTemplates {\n    edges {\n      node {\n        id\n        name\n        replyTo\n        subject\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bf1c208dff08feb0c4f63b83e6a490a2";

export default node;
